import React, { useEffect,useState } from 'react'
import { getCommentsListApi } from '../../API/AdminServices'
import Style from './CommentsList.module.css'
import ThreeHorseLoading from 'react-loadingg/lib/ThreeHorseLoading'
import { useHistory } from 'react-router-dom'

const CommentsList = () => {
    const history=useHistory()
    const[commentList,setCommentList]=useState()
    useEffect(()=>{
        getCommentList()
    },[])
    const getCommentList=async()=>{
        const data=await getCommentsListApi()
        setCommentList(data.comment)
    }
    const chatPageHandler=(id,user)=>{
       setTimeout(()=>history.push(`/chat/${id}`,user),200)
    }
    let loadingHandler=null
    if(commentList===undefined){
        loadingHandler=<ThreeHorseLoading/>
    }
    else{
        loadingHandler=commentList.slice(0).reverse().map(item=>{
            return(
                <ul key={item.id} className={Style.ReaportByTime}>
                    <li>سوال مربوط به دوره: <p>{item.course}</p></li>
                    <li>نام کاربر: <p>{item.user}</p></li>
                    <li> متن سوال: <p>{item.comment}</p></li>
                    <li>  تاریخ:  <p>{item.date}</p></li>
                    <li onClick={()=>chatPageHandler(item.id,item.user)}><p>شروع چت</p></li>
                </ul>
            )
        })
    }
    return (
        <div className={Style.PageHolder}>
            <div className={Style.ImageHolder}><img src="/Assets/Images/Comment/comment.svg" alt="electronicSteps" /></div>
            {
                loadingHandler
            }
        </div>
    )
}

export default CommentsList
